import { DisabledPrompt } from "bcms-react";
import { TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableItemView, TableView, WidgetContainer, WidgetView } from "components/shared";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function AcceptedDisclosuresWidget
 * @return {React.Component}
 * @exported true
 * @description Shows the Accepted Disclosures 
 */

export default function AcceptedDisclosuresWidget(props) {
  const disclosures = props.disclosures ?? [];
  const rows = disclosures.reduce((acc, disclosure) => {
    acc.push(
      <DisclosuresTableRow key={ disclosure.id } disclosure={ disclosure } />
    );
    return acc;
  }, []);
  
  return(
    <WidgetContainer className="accepted-disclosures-widget">
      <WidgetView text="Accepted Disclosures">
        <TableView>
          <TableColumnContainer>
            <TableColumnView className="text-left" text="View" />
            <TableColumnView className="text-left" text="Disclosure Title" />
            <TableColumnView className="text-left accepted-date" text="Accepted Date" />
          </TableColumnContainer>
          <TableBody>
            { rows }
          </TableBody>
        </TableView>
      </WidgetView>
    </WidgetContainer>
  );
}

/**
 * @function DisclosuresTableRow
 * @return {React.Component}
 * @exported false
 * @description Shows the Accepted Disclosures Table Row 
 */

function DisclosuresTableRow(props) {
  const disclosure = props.disclosure ?? {};
  return(
    <TableItemContainer>
      <TableItemView>
        <DisabledPrompt>
          <SVGAsset id="MagnifyingGlassIcon" className="clickable" />
        </DisabledPrompt>
      </TableItemView>
      <TableItemTextView text={ disclosure.title } />
      <TableItemTextView text={ disclosure.date.format('m/d/Y') } />
    </TableItemContainer>
  );
}